var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _path8, _rect5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330.67 250.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.73,116.79v43.37c0,5.46-4.41,9.89-9.88,9.89h-22.49c-1.21,1.32-2.66,2.37-4,2.89-5.99,2.34-12.22,4.2-18.23,5.99l-2.56.76c-2.13.64-4.07.97-5.86.97-4.64,0-8.28-2.19-11.58-6.79-.91-1.27-1.82-2.54-2.74-3.82H19.01c-5.46,0-9.89-4.43-9.89-9.89V37.63c0-5.46,4.43-9.88,9.89-9.88h189.26c1.87-1.38,3.7-2.79,5.51-4.24,2.65-2.14,5.26-4.39,7.82-6.7H16.06C7.19,16.81,0,24,0,32.87v148.46c0,8.87,7.19,16.06,16.06,16.06h230.55c8.88,0,16.06-7.18,16.06-16.04v-63.03c-3.64-.58-7.29-1.1-10.94-1.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.03,202.87c-.07,6.93-3.17,13.56-7.3,20.07h94.85c-3.86-5.63-6.29-12.32-7.3-20.07h-80.26Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.9,
    y: 230.23,
    width: 162.35,
    height: 20.07,
    rx: 3.02,
    ry: 3.02
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.67,153.01v4.4c0,1.49-.99,2.69-2.21,2.69H20.76c-1.22,0-2.21-1.2-2.21-2.69v-4.4c0-1.48.99-2.68,2.21-2.68h96.7c1.22,0,2.21,1.2,2.21,2.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.67,136.06v4.4c0,1.49-.99,2.69-2.21,2.69H20.76c-1.22,0-2.21-1.2-2.21-2.69v-4.4c0-1.48.99-2.68,2.21-2.68h96.7c1.22,0,2.21,1.2,2.21,2.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.67,119.11v4.4c0,1.49-.99,2.69-2.21,2.69H20.76c-1.22,0-2.21-1.2-2.21-2.69v-4.4c0-1.48.99-2.68,2.21-2.68h96.7c1.22,0,2.21,1.2,2.21,2.68Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.01,111.03c.95,3-.72,6.2-3.72,7.16-.94.3-1.88.6-2.81.9-.19.06-.37.12-.56.18-5.37,1.73-10.56,3.39-15.74,4.76-3.19.85-6.38,1.59-9.61,2.15-3.7.65-7.41.45-10.95-.47-9.73-2.51-16.39-10.2-21.11-19.97-.83-1.73-1.06-2.44-1.43-3.52-3.93-11.39,3.78-28.74,17.11-33.91,3.99-1.54,8.02-2.87,12.09-4.22,4-1.32,8.05-2.61,12.21-3.94.75-.24,1.5-.48,2.25-.72,3.01-.97,6.24.7,7.19,3.72l.3.94,1.87,5.94,2.54,8.06,1.56,4.94,2.54,8.06,1.87,5.94,2.54,8.06,1.87,5.94h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.78,132.09h-.83l.68-.22c.05.07.1.15.15.22Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.55,
    y: 94.73,
    width: 39.12,
    height: 10.36,
    rx: 2.21,
    ry: 2.21
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.55,
    y: 76.74,
    width: 39.12,
    height: 10.36,
    rx: 2.21,
    ry: 2.21
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.55,
    y: 60.03,
    width: 39.12,
    height: 10.36,
    rx: 2.21,
    ry: 2.21
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.67,44.24v25.22c-10.56,5.07-17.9,26.2-9.59,35.46h-43.32c-1.22,0-2.21-.99-2.21-2.21v-58.47c0-1.22.99-2.21,2.21-2.21h50.7c1.22,0,2.21.99,2.21,2.21Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.55,
    y: 42.03,
    width: 39.12,
    height: 10.36,
    rx: 2.21,
    ry: 2.21
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.67,57.18v5.6c0,.29-.03.59-.1.87-.44,1.92-.87,3.85-1.3,5.77-1.22,5.44-2.48,11.06-3.85,16.49l-.03.1c-.38,1.46-1.46,2.14-2.07,2.41-1.12.5-2.37.46-3.45-.1l-.7-.36c-1.76-.92-2.56-3.04-1.86-4.94,10.37-28.26.81-58.46-23.79-75.16-1.62-1.1-2.16-3.27-1.24-5.05l.36-.69c.53-1.02,1.44-1.73,2.57-2.01.32-.07.63-.11.95-.11.81,0,1.6.25,2.28.74,3.28,2.34,6.47,4.67,9.32,7.33,13.03,12.16,20.48,27.32,22.16,45.07.1,1.04.35,2.01.57,2.86l.05.19c.09.32.13.65.13.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.81,113.98c-.33.39-1.28,1.25-2.78.99l-4.05-.69c-4.06-.69-8.17-1.4-12.31-2.04-3.63-.56-7.29-1.08-10.94-1.5-2.74-.31-5.49-.57-8.23-.75-4.52-.31-9.01-.42-13.52-.42-6.04,0-12.13.2-18.42.41-4,.13-16.11,2.26-20.25,2.35l-1.65-5.24-2.54-8.06-1.87-5.94-2.53-8.06-1.56-4.94-2.54-8.06-1.87-5.94-2.53-8.06-.91-2.88c1.53-1.03,3.07-2.05,4.6-3.06,1.85-1.22,10.94-4.99,12.76-6.17,2.29-1.5,6.77-3.52,9-5,6.71-4.43,11.68-7.76,17.87-12.74.18-.14.35-.29.53-.43,4.26-3.46,8.38-7.16,12.38-10.94,3.58-3.39,7.08-6.83,10.53-10.22l3.02-2.97c1.09-1.07,2.36-.9,2.85-.78.49.13,1.68.57,2.14,2.02l4.2,13.36,9.48,30.13,19.74,62.75c.46,1.45-.26,2.5-.6,2.88Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.09,162.28c1.42,1.44,1.19,3.92-.57,4.9-.12.07-.24.12-.35.17-2.48.97-5.03,1.86-7.6,2.7-3.39,1.11-6.81,2.13-10.16,3.13l-2.56.76c-5.22,1.57-7.76.73-10.85-3.57-.08-.11-.15-.21-.23-.32-2.37-3.3-4.74-6.63-7.1-9.96-1.92-2.69-3.82-5.39-5.71-8.06-1.19-1.68-2.37-3.34-3.54-5l-.67-.94-3.8-5.37c2.8-.9,5.6-1.79,8.41-2.69,5.64-1.8,11.31-3.61,17.04-5.44l1.55-.5h.83c.95,1.42,1.88,2.82,2.81,4.23.38.57.75,1.14,1.13,1.71,1.78,2.68,3.61,5.4,5.51,8.06,1.2,1.67,2.42,3.33,3.69,4.94.27.34.55.67.83,1,1.85,2.1,4,3.86,6.1,5.58,1.03.84,2.02,1.65,2.95,2.48.4.36.79.72,1.17,1.09l.15.14c.25.24.6.58.97.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.78,132.09h-.83l.68-.22c.05.07.1.15.15.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.51,73.94c-.37,1.14-1.19,2.02-2.31,2.48-1.12.46-2.38.41-3.46-.15l-.13-.06c-1.74-.91-2.6-2.92-2.03-4.79,2.33-7.69,2.34-15.31.01-22.62-2.36-7.4-6.67-13.55-12.8-18.27-1.64-1.25-2.15-3.45-1.22-5.21l.08-.15c.56-1.07,1.51-1.81,2.68-2.08.32-.08.65-.12.97-.12.83,0,1.64.26,2.35.76,12.94,9.26,22.54,29.47,15.86,50.21Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/Marketing.693e5e447d5338139bd1fb681b645ff5.svg";
export { ForwardRef as ReactComponent };